<mat-spinner style="position:fixed;top:50%;left:50%" *ngIf="!load"></mat-spinner>

<div class="lti-otp" *ngIf="load">

  <!-- Left: marketing panel -->
  <aside class="lti-otp-left">
    <div class="lti-otp-left-inner">

      <a routerLink="/" class="lti-otp-logo">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">

      </a>

      <div class="lti-otp-hero">
        <h1>Verify your<br/>identity.</h1>
        <p>A 6-digit code was sent to your registered email. Enter it below to continue securely.</p>
      </div>

      <div class="lti-otp-security-card">
        <div class="lti-otp-sec-icon">
          <mat-icon>shield</mat-icon>
        </div>
        <div>
          <div class="lti-otp-sec-title">Why we verify</div>
          <div class="lti-otp-sec-desc">One-time codes protect your account from unauthorized access — even if your password is compromised.</div>
        </div>
      </div>

      <div class="lti-otp-tips">
        <div class="lti-otp-tip">
          <mat-icon>timer</mat-icon>
          <span>Code expires in <strong>10 minutes</strong></span>
        </div>
        <div class="lti-otp-tip">
          <mat-icon>inbox</mat-icon>
          <span>Check your spam folder if you don't see it</span>
        </div>
      </div>

      <div class="lti-otp-footer">
        <span>© 2026 LetsTimeIt Inc.</span>
      </div>

    </div>
  </aside>

  <!-- Right: form panel -->
  <main class="lti-otp-right">
    <form class="lti-otp-form-wrap" [formGroup]="verifyotpForm" (ngSubmit)="onSubmit()">

      <div class="lti-otp-lock-icon">
        <mat-icon>lock_outline</mat-icon>
      </div>

      <h2 class="lti-otp-title">Enter verification code</h2>
      <p class="lti-otp-sub">We sent a 6-digit code to your email address.</p>

      <div class="lti-otp-boxes">
        <div class="lti-otp-box" [class.lti-otp-box-filled]="frmCtrl.otp1.value">
          <input type="text" inputmode="numeric" [maxlength]="1" [minlength]="1"
            formControlName="otp1" class="lti-otp-input"
            (input)="moveToNext($event, otp2, null)" #otp1 autocomplete="one-time-code" />
        </div>
        <div class="lti-otp-box" [class.lti-otp-box-filled]="frmCtrl.otp2.value">
          <input type="text" inputmode="numeric" [maxlength]="1" [minlength]="1"
            formControlName="otp2" class="lti-otp-input"
            (input)="moveToNext($event, otp3, otp1)" #otp2 />
        </div>
        <div class="lti-otp-box" [class.lti-otp-box-filled]="frmCtrl.otp3.value">
          <input type="text" inputmode="numeric" [maxlength]="1" [minlength]="1"
            formControlName="otp3" class="lti-otp-input"
            (input)="moveToNext($event, otp4, otp2)" #otp3 />
        </div>
        <div class="lti-otp-dash">—</div>
        <div class="lti-otp-box" [class.lti-otp-box-filled]="frmCtrl.otp4.value">
          <input type="text" inputmode="numeric" [maxlength]="1" [minlength]="1"
            formControlName="otp4" class="lti-otp-input"
            (input)="moveToNext($event, otp5, otp3)" #otp4 />
        </div>
        <div class="lti-otp-box" [class.lti-otp-box-filled]="frmCtrl.otp5.value">
          <input type="text" inputmode="numeric" [maxlength]="1" [minlength]="1"
            formControlName="otp5" class="lti-otp-input"
            (input)="moveToNext($event, otp6, otp4)" #otp5 />
        </div>
        <div class="lti-otp-box" [class.lti-otp-box-filled]="frmCtrl.otp6.value">
          <input type="text" inputmode="numeric" [maxlength]="1" [minlength]="1"
            formControlName="otp6" class="lti-otp-input"
            (input)="moveToNext($event, null, otp5)" #otp6 />
        </div>
      </div>

      <div class="lti-err-block" *ngIf="error">{{error}}</div>

      <button class="lti-submit-btn" type="submit" [disabled]="!submitable">
        <span *ngIf="processing">Verifying...</span>
        <span *ngIf="!processing">Verify code</span>
      </button>

      <p class="lti-otp-resend">
        Didn't receive it? <a href="javascript:void(0)" (click)="resendOtp()" class="lti-link">Resend code</a>
      </p>

      <p class="lti-otp-hint">
        Back to <a routerLink="/" class="lti-link">Sign in</a>
      </p>

    </form>
  </main>

</div>
